<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18paPkf/tc-custom/9781504095679.jpg?1718182999685" alt="This image is the cover for the book Tower of Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tower of Love
      </h1>
      <p class="bookDescription body article font2">
        <b>Back at his family’s New England estate, a man finds a second chance at love—and a devastating truth—in this novel by the author of <i>Young Mr. Keefe</i>.</b><br/><br/> At thirty-one years of age, Hugh Carey has ended both his marriage and his advertising partnership. With his life at loose ends, he’s returned to the family home in Connecticut—that imposing castle built by his grandfather—to take stock and start over. His mother is only too happy to offer her counsel, as she does for Hugh’s sister Patsy. But her reputation as the most effective woman since Lady MacBeth is well earned.<br/><br/> Also delighted to have Hugh back is Edrita Everett Smith. She’s the girl next door—and the one who got away. As Hugh and Edrita reconnect, it seems that little has changed, and their old romance is ready to blossom again. But in this quiet, well-heeled suburb, nothing is as simple as it seems. As buried jealousies come to light and new schemes are hatched, Hugh will learn what it truly takes to forge his own path.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Birmingham
      </h2>
      
      <p class="authorDescription body article">Stephen Birmingham (1929&ndash;2015) was an American author of more than thirty books. Born in Hartford, Connecticut, he graduated from Williams College in 1953 and taught writing at the University of Cincinnati. Birmingham&rsquo;s work focuses on the upper class in America. He&rsquo;s written about the African American elite in <I>Certain People</I> and prominent Jewish society in <I>Our Crowd: The Great Jewish Families of New York</I>, <I>The Grandees: The Story of America&rsquo;s Sephardic Elite</I>, and <I>The Rest of Us: The Rise of America&rsquo;s Eastern European Jews</I>. His work also encompasses several novels including<I> The Auerbach Will</I>, <I>The LeBaron Secret</I>, <I>Shades of Fortune</I>, and <I>The Rothman Scandal</I>, and other non-fiction titles such as <I>California Rich</I>, <I>The Grandes Dames</I>, and <I>Life at the Dakota: New York&rsquo;s Most Unusual Address</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f9ee767